import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable, of } from 'rxjs';
import { Dao } from '../dao';
import { DataLoaderAuthentified } from '../data-loader-authentified';

@Injectable({
  providedIn: 'root',
})
export class AccountDao extends Dao {
  private account: DataLoaderAuthentified<any> =
    new DataLoaderAuthentified<any>(this.getAuthentified(), user => {
      return this.httpApi.get(`/accounts/${user.accountId}`);
    });

  private userAccount: DataLoaderAuthentified<any> =
    new DataLoaderAuthentified<any>(this.getAuthentified(), user => {
      return of(user?.userAccount || {});
    });

  private scoring: DataLoaderAuthentified<any> =
    new DataLoaderAuthentified<any>(this.getAuthentified(), user => {
      return this.httpApi.get(`/accounts/${user.accountId}/scoring`);
    });

  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  /* Account */
  getAccount(): Observable<any> {
    return this.account.get();
  }

  /* Account */
  getUserAccount(): Observable<any> {
    return this.userAccount.get();
  }

  getScoring(): Observable<any> {
    return this.scoring.get();
  }

  /* state */
  onUserChange(event: any) {
    this?.reset();
  }

  reset() {
    this.account?.reset();
    this.userAccount?.reset();
    this.scoring?.reset();
  }
}
